import React, { useEffect, useState } from 'react';
import { Row, Col, Image } from 'react-bootstrap';
import ZoomModal from './ZoomModal';
import {
  getSpecialCountTime,
  getUpcomingDate,
  getUpcomingTime
} from '../../../utils/camp.utils';
import ZoomButton from './ZoomButton';
import Avatar from '../../../assets/images/my_room_active.svg';
import dateEvents from '../../../assets/images/dateevents.svg';
import Time from '../../../assets/images/time.svg';
import DateImg from '../../../assets/images/date1.svg';
import './css/camp.schedule.scss';
import Countdown, { zeroPad } from 'react-countdown';
import ZoomButtonSpecialCamp from './ZoomButtonSpecialCamp';
import { format } from 'date-fns';
import { Typography } from '@mui/material';
import IIcon from '../../../assets/icon/PRINT.svg';
import TribeImg from '../../../assets/images/tour/Tribe_activities.svg';
import DreamCampImg from '../../../assets/images/tour/kid_dream_camp.svg';
import CampNoDataTooltip from '../school/camp_tour/CampNoDataTooltip';

const SpecialCampComp = ({ camp }) => {
  const getSpecialCampSchedule = () => {
    const convertedTime = getSpecialCountTime(
      camp?.end_date_time,
      camp?.timezone
    );
    return convertedTime;
  };

  const getSpecialCampDate = () => {
    const date = new Date(camp?.end_date_time);

    // Format the date using toLocaleDateString
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: '2-digit',
    };
    const formattedDate = date.toLocaleDateString('en-GB', options);

    return formattedDate;
  };

  const getSpecialCampTime = () => {
    const date = new Date(camp?.end_date_time);

    // Convert the date to the target timezone offset
    const options = { hour12: false, hour: '2-digit', minute: '2-digit' };
    const time = date.toLocaleTimeString('en-GB', options).replace(':', 'h');

    return `${time} (${camp?.timezone})`;
  };

  const countdownRenderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      // setIsCompleted(true)
      return (
        <div className="join-button px-3">
          <ZoomButtonSpecialCamp title="Join Camp" link={camp?.zoom_link} />
        </div>
      );
    } else {
      return (
        <h5 className="f-600">
          <div className="countdown">
            <div className="counts-days">
              <span id="days">{days}</span>
              <br />
              <span>Days</span>
            </div>
            <div className="counts-days">
              <span id="hrs">{zeroPad(hours)}</span>
              <br />
              <span>hrs</span>
            </div>
            <div className="counts-days">
              <span id="mins">{zeroPad(minutes)}</span>
              <br />
              <span>mins</span>
            </div>
            <div className="counts-days">
              <span id="secs">{zeroPad(seconds)}</span>
              <br />
              <span>secs</span>
            </div>
          </div>
        </h5>
      );
    }
  };

  return (
    <>
      <div className="camp-schedule-title p-3">{'Craft your beat!'}</div>
      <div className="inner-camp-box-my-room width-box">
        <div className="width-box camp-captain-profile-box">
          <h6 class="craft-meet">
            <Image
              src={
                camp?.created_by?.picture_url
                  ? camp?.created_by?.picture_url
                  : Avatar
              }
              alt=""
              className="date"
              width="40"
            />
            Meet the expert:{' '}
            <span>
              {' '}
              {camp?.created_by?.first_name} {camp?.created_by?.last_name}{' '}
            </span>
          </h6>

          <h6 class="craft-meet">
            <Image src={DateImg} alt="" className="date" width="40" />
            Date: {getSpecialCampDate()}
          </h6>

          <h6 class="craft-meet">
            <Image src={Time} alt="" className="date" width="40" />
            Time: {getSpecialCampTime()}
          </h6>

          <Countdown
            date={Date.now() + Number(getSpecialCampSchedule())}
            renderer={countdownRenderer}
          />
        </div>
      </div>
    </>
  );
};

const CampCamps = ({ selectedTribe, type, specialCamp }) => {
  const [showZoomModal, setShowZoomModal] = useState(false);
  const handleCloseZoomModal = () => setShowZoomModal(false);
  const [showCampJoin, setShowCampJoin] = useState(false);
  const [show, setShow] = useState(false);
  const [group, setGroup] = useState('');

  useEffect(() => {
    setGroup(selectedTribe);
  }, [selectedTribe]);
  const getSchedule = () => {
    const convertedTime = getUpcomingTime(
      group.day,
      group.time,
      group.timezone
    );
    return `${convertedTime}`;
  };

  const countdownRendererSchool = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }) => {
    if (completed) {
      // setShowCampJoin(true)
      return (
        <div className="join-button px-3">
          {group?.meet_link ? (
            <ZoomButtonSpecialCamp title="Join Camp" link={group?.meet_link} />
          ) : group?.zoom_link ? (
            <ZoomButtonSpecialCamp title="Join Camp" link={group?.zoom_link} />
          ) : (
            <ZoomButton title="Join Camp" creator={dependent} />
          )}
        </div>
      );
    } else {
      // setShowCampJoin(false)
      return (
        <h5 className="f-600">
          {/* <span>
            {days} Days:{zeroPad(hours)} Hrs:{zeroPad(minutes)} Mins:{zeroPad(seconds)} Secs
          </span> */}
          <div className="countdown">
            <div className="counts-days">
              <span id="days">{days}</span>
              <br />
              <span>Days</span>
            </div>
            <div className="counts-days">
              <span id="hrs">{zeroPad(hours)}</span>
              <br />
              <span>hrs</span>
            </div>
            <div className="counts-days">
              <span id="mins">{zeroPad(minutes)}</span>
              <br />
              <span>mins</span>
            </div>
            <div className="counts-days">
              <span id="secs">{zeroPad(seconds)}</span>
              <br />
              <span>secs</span>
            </div>
          </div>
        </h5>
      );
    }
  };

  const getDate = () => {
    const res = getUpcomingDate(group.day, group.time, group.timezone);
    return format(res, 'dd MMMM yyyy');
  };

  const getTime = () => {
    // Define the time and timezone
    const time = group.time;
    const timezone = group.timezone;
    return `${time} (${timezone})`;
  };

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const [showNoDataTooltip, setShowNoDataTooltip] = useState(false);
  const [stepData, setStepData] = useState([]);
  const noTribeStep = [
    {
      element: '#camp-no-tribe',
      intro: `
        <div class="custom-tour-step">
          <img src="${TribeImg}" alt="Camp Master" class="tour-avatar" />
          <h3>Monitor Tribe Activities</h3>
          <p>Keep track of all the creative and dream events across your camp.</p>
          <p>Select a tribe from the dropdown menu in your calendar.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip', // Custom tooltip class for CSS
      highlightClass: 'custom-highlight', // Custom highlight class for step highlighting
    },
  ];

  const noDreamCampStep = [
    {
      element: '#camp-no-dream-camp',
      intro: `
        <div class="custom-tour-step">
          <img src="${DreamCampImg}" alt="Camp Master" class="tour-avatar" />
          <h3>Dream Camp</h3>
          <p>Dream Camps are special experiences designed to help your child explore their deepest passions and unlock their full creative potential.</p>
          <p>Stay updated on upcoming Dream Camps and encourage your child to dive in!</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip', // Custom tooltip class for CSS
      highlightClass: 'custom-highlight', // Custom highlight class for step highlighting
    },
  ];

  const handleNoTribe = () => {
    setStepData(noTribeStep);
    setShowNoDataTooltip(true);
  };

  const handleNoDreamCamp = () => {
    setStepData(noDreamCampStep);
    setShowNoDataTooltip(true);
  };

  return (
    <div
      className="camp-schedule-container creator-camp-box justify-content-center text-center"
      style={{ boxShadow: 'unset' }}
    >
      <CampNoDataTooltip
        showTooltip={showNoDataTooltip}
        setShowTooltip={setShowNoDataTooltip}
        step={stepData}
      />
      {type === 'Creative' ? (
        group?.id ? (
          <>
            <div className="camp-schedule-title p-3">
              {group?.camp_details?.school_name
                ? group?.camp_details?.school_name
                : 'Upcoming Camp'}
            </div>
            <div className="inner-camp-box-my-room width-box">
              <div className="width-box camp-captain-profile-box countdown-div-btn">
                <h6 className="craft-meet tribe-image">
                  <Image
                    src={
                      group?.camp_details?.picture
                        ? group?.camp_details?.picture
                        : Avatar
                    }
                    alt=""
                    className="date"
                    width="40"
                  />
                  Tribe: <span> {group?.name} </span>
                </h6>

                <h6 className="craft-meet camp-image">
                  <Image
                    src={
                      group?.group_captain?.picture_url
                        ? group?.group_captain?.picture_url
                        : Avatar
                    }
                    alt=""
                    className="date"
                    width="40"
                  />
                  Your Camp Captain:{' '}
                  <span>
                    {' '}
                    {group?.group_captain?.first_name}{' '}
                    {group?.group_captain?.last_name}
                  </span>
                </h6>

                <h6 className="craft-meet">
                  <Image src={dateEvents} alt="" className="date" width="40" />
                  Date: {capitalizeFirstLetter(group?.day)} {getDate()}
                </h6>

                <h6 className="craft-meet">
                  <Image src={Time} alt="" className="date" width="40" />
                  Time: {getTime()}
                </h6>

                <Countdown
                  // key={key}
                  date={Date.now() + Number(getSchedule())}
                  renderer={countdownRendererSchool}
                  // overtime={true}
                  // onComplete={handleComplete}
                />
              </div>
              {showCampJoin
                ? !group.meet_link &&
                  group.zoom_link && (
                    <>
                      <Row
                        className={`p-3 justify-content-center camp-schedule-zoom-details`}
                      >
                        <Col className="col-auto">
                          <div className="camp-schedule-details">
                            Check Meeting Id & Password &gt;
                          </div>
                        </Col>
                      </Row>
                      <ZoomModal
                        showModal={showZoomModal}
                        handleClose={handleCloseZoomModal}
                      />
                    </>
                  )
                : ''}
            </div>
          </>
        ) : (
          <div
            className="insights-text no-data-found"
            style={{ paddingTop: '75px' }}
            id="camp-no-tribe"
          >
            <div className="text-wrapper">
              <Image
                src={IIcon}
                alt="no-data"
                className="add-pointer"
                onClick={handleNoTribe}
              />
              <Typography variant="body1" style={{ color: '#321b6d' }}>
                It looks like you haven't selected a tribe yet.
              </Typography>
            </div>
          </div>
        )
      ) : type === 'Special' && specialCamp?.id ? (
        <SpecialCampComp camp={specialCamp} />
      ) : (
        <div
          className="insights-text no-data-found"
          style={{ paddingTop: '75px' }}
          id="camp-no-dream-camp"
        >
          <div className="text-wrapper">
            <Image
              src={IIcon}
              alt="no-data"
              className="add-pointer"
              onClick={handleNoDreamCamp}
            />
            <Typography variant="body1" style={{ color: '#321b6d' }}>
              It looks like there aren't any Dream Camps added yet.
            </Typography>
          </div>
        </div>
      )}
    </div>
  );
};

export default CampCamps;